
// const BaseUrl = "http://localhost:8083";
const BaseUrl = "https://hsbtecms.hkcl.net";
// const BaseUrl = "https://cms.hsbte.org.in";

export default BaseUrl;